import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-card-header',
    templateUrl: './card-header.component.html',
    styleUrls: ['./card-header.component.scss'],
    standalone: false
})
export class CardHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
